import { Component, input } from '@angular/core';

@Component({
  selector: 'app-icon-check',
  standalone: true,
  imports: [],
  templateUrl: './icon-check.component.html',
  styleUrl: './icon-check.component.scss',
})
export class IconCheckComponent {
  width = input<string>('16');
  height = input<string>('16');
  color = input<string>('#011835');
}
